import { CommonModule } from '@angular/common';
import { Component, inject, signal, computed, OnInit } from '@angular/core';
import { SweetAlertService } from '@core/services/sweet-alert.service';

@Component({
  selector: 'app-public-bill-split-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './public-bill-split-footer.html',
})
export class PublicBillSplitFooterComponent implements OnInit {
  private sweetAlertService = inject(SweetAlertService);

  private _hasDonated = signal<boolean>(false);
  readonly showThankYouBanner = computed(() => this._hasDonated());

  ngOnInit() {
    const expiry = localStorage.getItem('dinno_thanks_expiry');
    const now = Date.now();

    if (expiry && now < parseInt(expiry)) {
      this._hasDonated.set(true);
    } else {
      this._hasDonated.set(false);
      localStorage.removeItem('dinno_thanks_expiry');
    }
  }

  onTecitoClick() {
    const expiryDate = Date.now() + 24 * 60 * 60 * 1000;
    localStorage.setItem('dinno_thanks_expiry', expiryDate.toString());
    this._hasDonated.set(true);

    this.sweetAlertService.showCustomRedirect({
      title: '¡Nos alegra que te sirva!',
      text: 'Tu apoyo es el combustible de Dinno para seguir calculando cuentas. ¡Sos crack!',
      imageUrl:
        'https://res.cloudinary.com/dgjd3ybs1/image/upload/v1774805899/dinno-festejo-cafecito_xznfhy.png',
      redirectUrl: 'https://tecito.app/dinnoapp',
      timer: 4500,
    });
  }

  resetDonationStatus() {
    localStorage.removeItem('dinno_thanks_expiry');
    this._hasDonated.set(false);
  }
}
